<template>
  <div
    class="badge"
    :class="{ 'badge--accent-alt': showBackground }"
  >
    <img
      class="symbol"
      :src="getStaticAssetUrl('/images/logo/ankorstore_plus_symbol.svg')"
      :alt="$t('ankorstorePlus.program.name')"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getStaticAssetUrl } from '@modules/shared/util/img-cdn/img-cdn';

export default defineComponent({
  name: 'AnkorstorePlusBadgeBrand',
  props: {
    showBackground: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return { getStaticAssetUrl };
  },
});
</script>
<style lang="scss" scoped>
.badge {
  @apply ds-rounded-full ds-flex ds-items-center ds-justify-center;
  width: 20px;
  height: 20px;
  &--accent-alt {
    @apply ds-bg-accent-alt ds-px-1 ds-py-1 ds-h-5 ds-w-5;
  }
}
</style>
